import React from 'react';
import {Box, Typography} from "@mui/material";

export interface TranscriptionBoxProps {
    transcript: string;
    uncompletedTranscript?: string;
}


const TranscriptBox: React.FC<TranscriptionBoxProps> = ({transcript, uncompletedTranscript}) => {
    console.info("TranscriptionBox received updated transcripts:", transcript, "Uncompleted:", uncompletedTranscript);

    return (
        <Box sx={{mt: '24px'}}>
            {!transcript && !uncompletedTranscript && (
                <Typography variant="body1" component="span" sx={{whiteSpace: "pre-line", color: 'text.secondary'}}>
                    Er is nog geen transcript.
                </Typography>
            )}
            {transcript && (
                <Typography variant="body1" component="span" sx={{whiteSpace: "pre-line"}}>
                    {transcript}
                </Typography>
            )}
            {uncompletedTranscript && (
                <Typography variant="body1" component="span" sx={{whiteSpace: "pre-line", color: '#d3d3d3', ml: 1}}>
                    {uncompletedTranscript}
                </Typography>
            )}
        </Box>
    );
};

export {TranscriptBox};
